import { useEffect, useState, useSyncExternalStore } from 'react';
import {
  getActiveSale,
  isPricingTierResolved,
  loadPricingTier,
  pricingTierVersion,
  subscribePricingTier,
} from '../utils/pricingTier';
import { leadsWithLifetime, regionalSaleLabel } from '../constants/regionalPricing';

/** Funnel views wait at most this long for the tier before firing untagged. */
const RESOLVE_TIMEOUT_MS = 1500;

/**
 * Server-resolved regional sale for the current visitor (shared store; every caller
 * re-renders when it resolves or when the sale end time passes).
 * List pricing (`tier: ''`) until /api/geo answers, when the sale is off, and after it ends.
 */
export default function usePricingTier() {
  useSyncExternalStore(subscribePricingTier, pricingTierVersion, pricingTierVersion);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const timer = setTimeout(() => {
      if (!cancelled) setTimedOut(true);
    }, RESOLVE_TIMEOUT_MS);
    loadPricingTier().finally(() => clearTimeout(timer));
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, []);

  const sale = getActiveSale();
  const tier = sale?.tier || '';
  return {
    tier,
    country: sale?.country || '',
    endsAt: sale?.endsAt || '',
    discounted: Boolean(sale),
    resolved: isPricingTierResolved() || timedOut,
    lifetimeFirst: Boolean(sale) && leadsWithLifetime(tier),
    label: sale ? regionalSaleLabel(sale.country, sale.endsAt, undefined, sale.timeZone) : '',
  };
}
